<template>
  <div class="product-space">
    <div class="h_product_bag">
      <h1>产品展示</h1>
      <div class="big-img">
        <div @click="seeProduct">
          <img :src="mainSHow" alt="" width="464" height="292">
        </div>
      </div>
      <div class="product-list">
        <el-row :gutter="20">
          <el-col :span="2">
            <div class="ctlArrow" @click="goImg(2)">
              <img :src="arrawback" alt="" width="22" height="32">
            </div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="6">
              <el-col :span="4" v-for="(item,index) in showArr" :key="index">
                <div @click="bigShow(item)" class="list-imgs">
                  <img :src="item.path" :alt="item.name" width="160" height="120">
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2">
            <div class="ctlArrow" @click="goImg(1)">
              <img :src="arrawfront" alt="" width="22" height="32">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { homeProduct } from '@/api/frontApi/frontHome';
import { backLoop, forwardLoop } from '@/common/util/pictureLoop';
export default {
  data() {
    return {
      swiperList: [
        { path: '../../../../static/img/product/1.png', index: 1 },
        { path: '../../../../static/img/product/2.png', index: 2 },
        { path: '../../../../static/img/product/3.png', index: 3 },
        { path: '../../../../static/img/product/4.png', index: 4 },
        { path: '../../../../static/img/product/5.png', index: 5 },
        { path: '../../../../static/img/product/6.png', index: 6 },
        { path: '../../../../static/img/product/7.png', index: 7 }
      ],
      pdocList: [],
      bannerHight: 220,
      mainSHow: '', // 大图展示图片路径
      mainId: 0, // 大图对应产品的ID
      arrawback: '../../../../static/img/product/hou.png',
      arrawfront: '../../../../static/img/product/qian.png',
      showArr: []
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    getProductList() {
      homeProduct({ pageNo: 1, pageSize: 500, recommend: 1 }).then(res => {
        res.data.list.forEach(item => {
          let tempObj = { path: '', name: '', index: '' };
          tempObj.path = item.productImg;
          tempObj.name = item.productName;
          tempObj.index = item.productId;
          this.pdocList.push(tempObj);
        });
        this.showArr = this.pdocList.slice(0, 6);
        this.bigShow(this.showArr[0]);
      });
    },
    goImg(ctlNo) {
      switch (ctlNo) {
        case 1:
          this.showArr = forwardLoop(this.showArr, this.pdocList, 'index');
          break;
        case 2:
          this.showArr = backLoop(this.showArr, this.pdocList, 'index');
          break;
      }
    },
    bigShow(item) {
      this.mainSHow = item.path;
      this.mainId = item.index;
    },
    seeProduct() {
      let hProductRoute = this.$router.resolve({
        name: 'productInfo',
        query: parseInt(this.mainId),
        params: {
          productId: parseInt(this.mainId)
        }
      });
      window.open(hProductRoute.href, '_blank');
    }
  }
};
</script>
<style scoped>
.product-space {
  width: 100%;
  text-align: center;
}
.h_product_bag {
  width: 80%;
  margin: 0 auto;
  padding-top: 5px;
}
.big-img {
  width: 45%;
  min-width: 500px;
  text-align: center;
  margin: 0 auto 15px;
  cursor: pointer;
}
.product-list {
  width: 80%;
  margin: 0 auto;
}
.ctlArrow {
  margin-top: 40px;
  cursor: pointer;
}
.list-imgs {
  width: 160px;
  height: 120px;
  overflow: hidden;
  cursor: pointer;
}
.list-imgs img:hover {
  transform: scale(1.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeProduct.vue